import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core'

@Directive({
  selector: '[href]',
  host: { '(click)': 'preventDefault($event)' }
})
export class HrefPreventDefaultDirective implements AfterViewInit {
  @Input() public href: string

  constructor (private el: ElementRef) {}
  public ngAfterViewInit () {}
  public preventDefault (event) {
    if (this.href.length === 0 || this.href === '#') {
      event.preventDefault()
    }
  }
}
